export const environment = {
  production: true,
  frontEndTest: false,
};
